module.exports = __webpack_public_path__ + "img/qrcode.f3dc3111.jpg";